import Store from 'store/store';
import cached from 'utils/cached';
import { accessNested } from 'utils/utils';

// const HTML_COLOR_REG = /^#([0-9a-f]{3}){1,2}$/i;
// function colorHtmlToHex(str) {
// 	let d = str.substr(1);
// 	if (d.length === 3) {
// 		d = d[0] + d[0] + d[1] + d[1] + d[2] + d[2];
// 	}
// 	return '0x' + d.toLowerCase();
// }

// function googleMapStyleToQueryString(rules) {
// 	if (!Array.isArray(rules)) return [];
// 	return rules.map(rule => {
// 		let parts = [];
// 		let add = (key, val) => key && val && parts.push(key + ':' + val);
// 		add('feature', rule.featureType);
// 		add('element', rule.elementType);
// 		if (Array.isArray(rule.stylers)) {
// 			rule.stylers.forEach(style => {
// 				Object.keys(style).forEach(key => {
// 					let value = style[key];
// 					if (HTML_COLOR_REG.test(value)) {
// 						value = colorHtmlToHex(value);
// 					}
// 					add(key, value);
// 				});
// 			});
// 		}
// 		return parts.join('|');
// 	});
// }

function getMapStyles() {
	let mapStyles = accessNested(Store.get(), 'appData.doc.mapStyling.gmaps.mapStyles', []);
	return (Array.isArray(mapStyles) ? mapStyles : Object.values(mapStyles)).filter(e => e);
}

export const getGMaps = cached(async () => {
	if (typeof window === 'undefined') {
		// Google Maps is already initialized
		return undefined;
	}
	if (window.google && window.google.maps) {
		return window.google.maps;
	}
	return new Promise((resolve, reject) => {
		window.googleMapsLoaded = () => resolve(window.google.maps);
		const gmapsData = accessNested(Store.get(), 'appData.doc.mapStyling.gmaps') || {};
		const gmapsKey = gmapsData.key || accessNested(Store.get(), 'appData.apis.gmaps.key');
		const options = {
			key:       gmapsKey,
			libraries: ['places', 'geometry'],
			callback:  'googleMapsLoaded'
		};
		if (gmapsData.language) {
			options.language = gmapsData.language;
		}
		const queryString = '?' + Object.keys(options).reduce((result, key) => {
			let val = options[key];
			// Keep loose equality, means null or undefined
			if (val != undefined) {
				result.push(key + '=' + options[key]);
			}
			return result;
		}, []).join('&');

		const script = document.createElement('script');
		script.onerror = reject;
		script.src = 'https://maps.googleapis.com/maps/api/js' + queryString;
		document.head.appendChild(script);
	});
});

export const mount = async (dom, opts) => {
	if (!dom) {
		return;
	}
	let gmaps = await getGMaps();

	const options = Object.assign({
		center: { lat: 51.5074, lon: -0.1278 },
		zoom: 12,
		clickableIcons: false,
		controlSize: 32,
		disableDefaultUI: true,
		mapTypeId: gmaps.MapTypeId.ROADMAP,
		mapTypeControlOptions: { mapTypeIds: [gmaps.MapTypeId.ROADMAP, 'map_style'] },
		zoomControl: true,
		zoomControlOptions: { position: gmaps.ControlPosition.LEFT_BOTTOM },
		gestureHandling: 'greedy',
	}, opts);

	options.center = new gmaps.LatLng(options.center.lat, options.center.lon);
	const googleMap = new google.maps.Map(dom, options);

	let mapStyles = getMapStyles();

	if (mapStyles) {
		const styledMap = new google.maps.StyledMapType(mapStyles, { name: 'Styled Map' });
		googleMap.mapTypes.set('map_style', styledMap);
		googleMap.setMapTypeId('map_style');
	}

	return googleMap;
};
